import { render, staticRenderFns } from "./CaseAnalysisQuestions.vue?vue&type=template&id=64d4e402&scoped=true"
import script from "./CaseAnalysisQuestions.vue?vue&type=script&lang=js"
export * from "./CaseAnalysisQuestions.vue?vue&type=script&lang=js"
import style0 from "./CaseAnalysisQuestions.vue?vue&type=style&index=0&id=64d4e402&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4e402",
  null
  
)

export default component.exports